import { render, staticRenderFns } from "./AlbumDetail.vue?vue&type=template&id=02ebe9cf"
import script from "./AlbumDetail.vue?vue&type=script&lang=js"
export * from "./AlbumDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02ebe9cf')) {
      api.createRecord('02ebe9cf', component.options)
    } else {
      api.reload('02ebe9cf', component.options)
    }
    module.hot.accept("./AlbumDetail.vue?vue&type=template&id=02ebe9cf", function () {
      api.rerender('02ebe9cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/album/AlbumDetail.vue"
export default component.exports